export const triggerPortalShellRefresh = () => window.PortalShell?.AccountAndTenants?.fetchAccountAndTenants(true);
